import {Children} from 'react';
import {Select as AntSelect} from "antd";

export function getOptions(options, children, optionLabelProp) {
    if (options !== undefined)
        return options;

    const newOptions = [];
    Children.forEach(children, function iter(child) {
        const { props } = child || {};
        switch (child?.type) {
            case AntSelect.Option: {
                const {
                    value,
                    children,
                } = child.props;
                const label = optionLabelProp ? child.props[optionLabelProp] : children;
                newOptions.push({
                    value,
                    option: children,
                    label,
                });
                break;
            }
            case AntSelect.OptGroup:
            default:
                if (props?.children)
                    Children.forEach(props.children, iter);
                break;
        }
    });
    return newOptions;
}

export const SelectHelper = {

    // getCurriedPopupContainer: (popupContainerId, popupType) => trigger => {
    //     // for tooltips within report-wrapper (eg Location tag in Inventory Detail), and where the report itself is scrollable,
    //     // set popupType to parent for the tooltip to follow the scrolling of the report itself
    //     if (trigger.closest(".report-wrapper") && !(popupType || popupContainerId))
    //         return (SelectHelper.getPopupContainer(null, "parent"))(trigger);

    //     return SelectHelper.getPopupContainer(popupContainerId, popupType)(trigger);
    // },

    /**
     * popupContainerId: used by other components, eg AutoComplete, Select etc.
     *
     * popupType:
     * - used by BukkuTooltip.
     *
     * - For drawer and modal, it'll only work if the tooltip is inside a Row and Col component.
     * If there's no Row/Col, popupContainer from querySelector will return null, and so the popupContainer
     * will default to bukkuContent/parent element.
     *
     * - For 'select-dropdown', we have to use trigger.closest, as using querySelector may cause some issues
     * with virtual lists.
     */
    // getPopupContainer(popupContainerId, popupType) {
    //     let popupContainer;

    //     // If the ID is explicitly given. Eg. Sign up page: "sign-up-popup-parent", shoebox form: "formContent"
    //     if (popupContainerId) {
    //         if (typeof popupContainerId === "string") {
    //             if (popupContainerId === 'parentElement')
    //                 return trigger => trigger.parentElement;
    //             popupContainer = document.getElementById(popupContainerId);
    //         }
    //         // popupContainer = document.getElementById(popupContainerId);
    //     }
    //     else {
    //         switch (popupType) {
    //             case 'parent': // eg. Transaction table fixed pagination header Bulk action buttons
    //                 return trigger => trigger.parentElement;

    //             case 'tree-item': // eg. Shoebox List
    //                 popupContainer = document.querySelector('.ant-tree .ant-row');
    //                 break;
    //             case 'select-dropdown': // eg. Product, Contact Select
    //                 // popupContainer = document.querySelector('.product-select-dropdown .ant-select-item');
    //                 return trigger => trigger.closest('.ant-select-item');
    //             case 'drawer':
    //                 popupContainer = document.querySelector('.ant-drawer-body .ant-row .ant-col');
    //                 break;
    //             case 'modal':
    //                 popupContainer = document.querySelector('.ant-modal-body .ant-row .ant-col');
    //                 break;
    //             case 'topbar':
    //                 popupContainer = document.querySelector('.isomorphicTopbar');
    //                 break;

    //             case 'content':
    //             default:
    //                 popupContainer = document.getElementById('bukkuContent');
    //                 break;
    //         }
    //     }

    //     return trigger => (popupContainer || document.getElementById('bukkuContent') || trigger.parentElement);
    // },

    // Deprecated: getPopupContainer accepts popupContainerId as false, string, 'parentElement' and null
    getPopupContainer(popupContainerId) {
        const bukkuContent = document.getElementById('bukkuContent');
        if (popupContainerId === undefined || popupContainerId === false) {
            return trigger => (
                bukkuContent ?
                    document.getElementById('bukkuContent') : trigger.parentElement
            );
        }

        if (typeof popupContainerId === "string") {
            if (popupContainerId === 'parentElement')
                return trigger => trigger.parentElement;
            return () => document.getElementById(popupContainerId);
        }
        return null;
    },
};
